import siteContent from "@/content/site.json";
import servicesContent from "@/content/services.json";
import serviceAreasContent from "@/content/serviceAreas.json";
import homeContent from "@/content/home.json";
import faqsContent from "@/content/faqs.json";

export const SITE = siteContent;
export const SERVICES = servicesContent.services;
export const BRANDS = servicesContent.brands;
export const SERVICE_AREAS = serviceAreasContent.areas;
export const PROCESS_STEPS = homeContent.process.steps;
export const WHY_FEATURES = homeContent.whyChooseUs.features;
export const HOME_FAQS = faqsContent.items;
